import { CardAdminInfo } from "./card-admin";
import { IPerson } from "./person";

export enum VALORFRETECAMPO {
  NAO_DEVOLVER = 1,
  PROPRIO = 2,
  DESPESAS = 3,
  PROPRIO_SEM_BC = 4
}

export enum DEVOLUCAO_ICMSST {
  /**
   * Não realiza tratamento
   * @default
   */
  NAO_TRATAR = 1,

  /** Soma ao valor do produto e lista nos dados adicionais da nota */
  SOMAR_PRODUTO = 2,

  /** Soma ao valor de despesas e lista nos dados adicionais da nota */
  SOMAR_DESPESAS = 3,

  NAO_DEVOLVER = 4
}

export enum DEVOLUTION_OTHERS {
  DO_NOT_DEVOLVE = 1,
  DEVOLVE_AND_NOT_SUM_BC = 2,
  DEVOLVE_AND_SUM_BC = 3
}


export interface Supplier extends IPerson {
  profession?: string;
  cardAdmin?: CardAdminInfo[]
  // cardAdmin?: { tax: number, portion: number }[];
  documentType?: number;

  isTransporter?: boolean;

  /** rg or stateRegistration */
  rg?: string;
  insMun?: string;
  /**
   * @todo
   */
  fancyName?: string;
  creditCrad?: string
  deditCrad?: string

  freightField?: VALORFRETECAMPO;
}
